// loading.js
import { Loading } from 'element-ui'

let loadingInstance = null

export default {
  // 显示 loading
  show(options = {}) {
    const defaultOptions = {
      lock: true,
      text: '加载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)',
       ...options
    }
    
    if (!loadingInstance) {
      loadingInstance = Loading.service(defaultOptions)
    }
    return loadingInstance
  },

  // 隐藏 loading
  hide() {
    if (loadingInstance) {
      loadingInstance.close()
      loadingInstance = null
    }
  }
}